module.exports = __webpack_public_path__ + "static/img/chart-pic12.9667f289.png";